/**
 * Default to recent data, while keeping a series whose last edition is older usable. Never wider
 * than the 50 years a report query accepts, however far apart the editions are.
 */
export function defaultReportYears(years: number[], currentYear = new Date().getUTCFullYear()) {
  const toYear = Math.max(...years)
  const recent = Math.min(toYear, Math.max(Math.min(...years), currentYear - 5))
  return { fromYear: Math.max(recent, toYear - 49), toYear }
}
